import { useEffect, useState } from "react";
import { BsPlusCircleFill } from "react-icons/bs";
import {
  Button,
  Form,
  Row,
  Col,
  Accordion,
  Card,
  Alert,
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import Get from "../../api/Get";
import Post from "../../api/Post";
import {
  FICHA_EPIDEMIOLOGICA_GET_BY_APPOINTMENT,
  FICHA_EPIDEMIOLOGICA_SAVE,
  FICHA_EPIDEMIOLOGICA_GET_BY_ID,
  FICHA_EPIDEMIOLOGICA_UPDATE,
} from "../../api/Routes";
import QuestionTemplate from "../QuestionTemplate";
import SimpleLoad from "../../loader/SimpleLoad";
import { RiPencilFill } from "react-icons/ri";
import { getElementoInside } from "../../utils/getElementoInside";
import Put from "../../api/Put";
import moment from "moment";
import {canEditDoctor} from "../../utils/isDoctor";

function FichaEpidemiologicaColombia({
  t,
  notify,
  appointmentId,
  idHM,
  auth,
  idSpeciality,
  setShowModalServer,
  setErrorServer,
  readOnly,
  scrollRef, cita
}) {
  const [medical, setMedical] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [idHistoriaClinica, setIdHistoriaClinica] = useState(idHM);
  const [preguntas, setPreguntas] = useState([]);
  const [respuesta, setRespuesta] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rechckedMH, setRecheckMH] = useState(true);
  const [doSave, setDoSave] = useState(false);
  const [objError, setObjError] = useState({
    Estrato: {
      error: false,
      text: "",
    },
  });

  useEffect(() => {
    let id = idHistoriaClinica ? idHistoriaClinica : idHM;
    if (id && rechckedMH) {
      let mounted = true;
      setLoading(true);
      Get({
        url: `${FICHA_EPIDEMIOLOGICA_GET_BY_ID}/${id}`,
        access_token: auth.data.access_token,
      })
        .then((response) => {
          //console.log(response)
          if (mounted) {
            setMedical(response.data.data.questionsDTOList);
            setRecheckMH(false);
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
          setShowModalServer(true);
          if (error.response) {
            setErrorServer(error.response);
          }
        });
      return () => (mounted = false);
    }
  }, [idHM, idHistoriaClinica, rechckedMH]);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    Get({
      url: `${FICHA_EPIDEMIOLOGICA_GET_BY_APPOINTMENT}/${appointmentId}`,
      access_token: auth.data.access_token,
    })
      .then((response) => {
        if (mounted) {
          //console.log(response)
          setPreguntas(response.data.data.response);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        setShowModalServer(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
    return () => (mounted = false);
  }, []);

  const handleShowForm = () => setShowForm(!showForm);

  const buildJson = (valor, idPregunta) => {
    const data = {
      id: idPregunta,
      note: "",
      qualificationDTOS: [
        {
          id: valor,
        },
      ],
    };
    let arr = [...respuesta];
    const index = arr.findIndex((item) => item.id === idPregunta);
    if (index >= 0) {
      arr[index] = data;
      setRespuesta(arr);
    } else {
      setRespuesta((respuesta) => [...respuesta, data]);
    }

    //actualizar la pregunta
    let arrP = [...preguntas];
    let indexPre = preguntas[0].questions.findIndex(
      (el) => el.id === idPregunta
    );
    if (indexPre >= 0) {
      let a = arrP[0].questions[indexPre].qualifications.map((el) => ({
        ...el,
        selected: "",
      }));
      arrP[0].questions[indexPre].qualifications = a;
      let indexQ = arrP[0].questions[indexPre].qualifications.findIndex(
        (el) => el.id === parseInt(data.qualificationDTOS[0].id)
      );
      if (indexQ >= 0) {
        arrP[0].questions[indexPre].qualifications[indexQ].selected =
          "selected";
      }
    }
  };

  const buildJsonDate = (valor, idPregunta) => {
    const data = {
      id: idPregunta,
      note: moment(valor).format("DD/MM/YYYY"),
    };
    let arr = [...respuesta];
    const index = arr.findIndex((item) => item.id === idPregunta);
    if (index >= 0) {
      arr[index] = data;
      setRespuesta(arr);
    } else {
      setRespuesta((respuesta) => [...respuesta, data]);
    }

    //le respondemos la pregunta
    let arrP = [...preguntas];
    let indexPre = preguntas[0].questions.findIndex(
      (el) => el.id === idPregunta
    );
    if (indexPre >= 0) {
      arrP[0].questions[indexPre]["note"] = valor;
      setPreguntas(arrP);
    }
    setDoSave(true);
  };

  const builJsonText = (valor, idPregunta) => {
    const data = {
      id: idPregunta,
      note: valor,
    };

    let arr = [...respuesta];
    const index = arr.findIndex((item) => item.id === idPregunta);
    if (index >= 0) {
      arr[index] = data;
      setRespuesta(arr);
    } else {
      setRespuesta((respuesta) => [...respuesta, data]);
    }

    //le respondemos la pregunta
    let arrP = [...preguntas];
    let indexPre = preguntas[0].questions.findIndex(
      (el) => el.id === idPregunta
    );
    if (indexPre >= 0) {
      arrP[0].questions[indexPre]["note"] = valor;
      setPreguntas(arrP);
    }
  };

  const builJsonMultiple = (checked, valor, idPregunta) => {
    let arr = [...respuesta];
    const index = arr.findIndex((item) => item.id === idPregunta);
    if (index >= 0) {
      const index2 = arr[index].qualificationDTOS.findIndex(
        (item) => item.id === valor
      );
      if (checked) {
        const d = {
          id: valor,
        };
        let arr3 = [...arr[index].qualificationDTOS, d];
        arr[index].qualificationDTOS = arr3;
        setRespuesta(arr);
      } else {
        if (index2 >= 0) {
          arr[index].qualificationDTOS.splice(index2, 1);
        }
      }
    } else {
      if (checked) {
        const data = {
          id: idPregunta,
          note: "",
          qualificationDTOS: [
            {
              id: valor,
            },
          ],
        };
        setRespuesta((respuesta) => [...respuesta, data]);
      }
    }

    //le respondemos la pregunta
    let arrP = [...preguntas];
    let indexPre = arrP[0].questions.findIndex((el) => el.id === idPregunta);
    if (indexPre >= 0) {
      let indQ = arrP[0].questions[indexPre].qualifications.findIndex(
        (el) => el.id === parseInt(valor)
      );
      let arrMutar = [...arrP[0].questions[indexPre].qualifications];
      if (checked) {
        arrMutar[indQ].selected = "selected";
        arrMutar[indQ].checked = true;
      } else {
        arrMutar[indQ].selected = null;
        arrMutar[indQ].checked = null;
      }

      arrP[0].questions[indexPre].qualifications = arrMutar;
      setPreguntas(arrP);
    }
  };

  const onClickEnviar = (kForm) => {
    const respArray = respuesta.filter((it) => it.id === 127);
    if (
      respArray.length === 0 ||
      (respArray.length > 0 && respArray[0].qualificationDTOS[0].id === "")
    ) {
      console.log("error");
      setObjError({
        ...objError,
        Estrato: {
          error: true,
          text: "Campo estrato es requerido",
        },
      });
      //scrollRef.current.scrollTo(0, 130)
    } else {
      setObjError({
        ...objError,
        Estrato: {
          error: false,
          text: "",
        },
      });
      const data = {
        appointmentDTO: {
          id: appointmentId,
        },
        questionOfGroupDTOS: respuesta,
      };

      //console.log(data)

      setLoading(true);

      Post({
        url: FICHA_EPIDEMIOLOGICA_SAVE,
        data: data,
        header: true,
        access_token: auth.data.access_token,
      })
        .then((response) => {
          setIdHistoriaClinica(response.data.data.id);
          if (!kForm) {
            setShowForm(!showForm);
          }
          setRecheckMH(true);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          setShowModalServer(true);
          if (error.response) {
            setErrorServer(error.response);
          }
          if (!kForm) {
            setShowForm(!showForm);
          }
        });
    }
  };

  const handleEditEnviar = (kForm) => {
    let arr = [...respuesta];
    let arrCasillas = preguntas[0].questions.filter(
      (el) => el.questionType.tipoPregunta.id === 2
    );
    if (arrCasillas.length > 0) {
      let arrChecked = getElementoInside(arrCasillas, arr);
      arrChecked.forEach((element) => {
        let index = arr.findIndex((e) => e.id === element.id);
        if (index >= 0) {
          arr[index].qualificationDTOS = element.checked;
        } else {
          const dAux = {
            id: element.id,
            note: "",
            qualificationDTOS: element.checked,
          };
          arr.push(dAux);
        }
      });
    }
    const respArray = arr.filter((it) => it.id === 127);
    const respPreg =
      preguntas.length > 0
        ? preguntas[0].questions.filter((it) => it.id === 127)
        : [];
    if (
      (respArray.length === 0 &&
        respPreg[0].qualifications.filter(
          (it) => it.selected === "selected"
        ) === 0) ||
      (respArray.length > 0 && respArray[0].qualificationDTOS[0].id === "")
    ) {
      console.log("error");
      setObjError({
        ...objError,
        Estrato: {
          error: true,
          text: "Campo estrato es requerido",
        },
      });
      //scrollRef.current.scrollTo(0, 130)
    } else {
      setObjError({
        ...objError,
        Estrato: {
          error: false,
          text: "",
        },
      });
      const data = {
        appointmentDTO: {
          id: appointmentId,
        },
        questionOfGroupDTOS: arr,
      };
      //console.log(data)
      setLoading(true);
      Put({
        url: FICHA_EPIDEMIOLOGICA_UPDATE,
        data: data,
        header: true,
        access_token: auth.data.access_token,
      })
        .then((response) => {
          setIdHistoriaClinica(response.data.data.id);
          if (!kForm) {
            setShowForm(!showForm);
          }
          setRecheckMH(true);
          setLoading(false);
        })
        .catch((error) => {
          setShowModalServer(true);
          if (error.response) {
            setErrorServer(error.response);
          }
          setLoading(false);
          if (!kForm) {
            setShowForm(!showForm);
          }
        });
    }
  };

  const handleShowEditForm = () => {
    let arr = [...preguntas];
    medical[0].questionOfGroupDTOS.forEach((element) => {
      let index = arr[0].questions.findIndex((e) => e.id === element.id);
      arr[0].questions[index].qualifications = element.qualificationDTOS;
      arr[0].questions[index].note = element.note;
    });
    setPreguntas(arr);
    setShowForm(true);
  };

  useEffect(() => {
    if (doSave) {
      const timeoutID = setTimeout(() => {
        if (idHM || idHistoriaClinica) {
          handleEditEnviar(true);
        } else {
          onClickEnviar(true);
        }
        setDoSave(false);
      }, 1000);

      return () => {
        clearTimeout(timeoutID);
      };
    }
  }, [doSave]);

  return (
    <div className="p-3 pt-4 position-relative">
      {loading && <SimpleLoad />}
      {!showForm && (idHM || idHistoriaClinica) && !readOnly && canEditDoctor(cita, auth) && (
          <Button
              variant="outline-info"
              className="position-absolute right-absolute"
              size="sm"
              onClick={handleShowEditForm}
          >
            <RiPencilFill />
          </Button>
      )}

      {!showForm ? (
        <>
          {!idHistoriaClinica && !idHM && !readOnly && canEditDoctor(cita, auth) && (
            <div className="cita-btn-add-container" onClick={handleShowForm}>
              <BsPlusCircleFill className="cita-btn-add-item" /> &nbsp;
              <Button variant="outline-primary" type="button" size="sm">
                Crear ficha epidemiológica
              </Button>{" "}
            </div>
          )}

          {(idHistoriaClinica || idHM) &&
            medical.map(
              (item, i) =>
                item.questionOfGroupDTOS.length > 0 && (
                  <div key={i}>
                    <label className="font-weight-bold font-size-08rem mb-1 text-secondary">
                      {item.questionGroup}
                    </label>
                    <ul className="list-unstyled font-size-08rem pl-3 color-989898">
                      {item.questionOfGroupDTOS.map((subIt, subI) => (
                        <li key={subI}>
                          <span className="font-weight-bold-600">
                            {subIt.label}:{" "}
                          </span>
                          {subIt.qualificationDTOS.length > 0
                            ? subIt.qualificationDTOS
                                .filter((q) => q?.selected === "selected")
                                .map((el) => el.label)
                                .join(",")
                            : subIt.note}
                        </li>
                      ))}
                    </ul>
                  </div>
                )
            )}
        </>
      ) : (
        <>
          <Form className="mt-3">
            {objError.Estrato.error && (
              <Alert variant="danger" className="p-1">
                {objError.Estrato.text}
              </Alert>
            )}
            {preguntas.map((pregunta, p) => {
              return pregunta?.questions.length > 0 ? (
                <Row
                  className="historia-clinica-questions-container"
                  key={`pregunta-${p}`}
                >
                  <Col>
                    <Accordion defaultActiveKey={p === 0 ? "0" : ""}>
                      <Card>
                        <Card.Header>
                          <Accordion.Toggle
                            as={Button}
                            variant="link"
                            eventKey="0"
                          >
                            {pregunta?.questionGroup}
                          </Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse eventKey="0">
                          <Card.Body>
                            {pregunta?.questions.map((question, q) => {
                              return (
                                <Form.Group key={q}>
                                  <Form.Label>
                                    {question.questionType?.label}
                                  </Form.Label>
                                  <QuestionTemplate
                                    questionId={question.id}
                                    questionType={question.questionType}
                                    qualifications={question.qualifications}
                                    buildJson={buildJson}
                                    builJsonText={builJsonText}
                                    builJsonMultiple={builJsonMultiple}
                                    isUpdate={false}
                                    note={question.note}
                                    buildJsonDate={buildJsonDate}
                                    setDoSave={setDoSave}
                                  />
                                </Form.Group>
                              );
                            })}
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    </Accordion>
                  </Col>
                </Row>
              ) : (
                <div key={`pregunta-${p}`}></div>
              );
            })}

            <Row className="grupoBotones">
              <Col>
                <Button
                  variant="danger"
                  className="cancelar-buttom"
                  type="button"
                  onClick={handleShowForm}
                >
                  {" "}
                  {t("cancelar")}{" "}
                </Button>{" "}
              </Col>
              <Col className="text-right">
                {idHM || idHistoriaClinica ? (
                  <Button
                    variant="outline-success"
                    className="ok-buttom"
                    type="button"
                    onClick={() => {
                      handleEditEnviar(false);
                    }}
                  >
                    {t("aceptar")}
                  </Button>
                ) : (
                  <Button
                    variant="outline-success"
                    className="ok-buttom"
                    type="button"
                    onClick={() => {
                      onClickEnviar(false);
                    }}
                  >
                    {t("aceptar")}
                  </Button>
                )}
              </Col>
            </Row>
          </Form>
        </>
      )}
    </div>
  );
}

export default withTranslation()(FichaEpidemiologicaColombia);
